<template>
    <div class="container-warp">
        <!-- banner -->
        <div class="section section_1" id="section_1">
            <img class="se-img"  v-lazy="PCimglist[0].url">
        </div>
        <div class="section section_2" id="section_2">
            <img class="se-img"  v-lazy="PCimglist[1].url">
            <div class="content">
                <div class="c-1 flex center-wrap">
                    <div class="left flex">
                        <div class="flex" v-for="(item,index) in bannerData" :key="item.title">
                            <div class="item">
                                <div class="title" >{{item.title}}</div>
                                <div class="des">{{item.des}}</div>
                            </div>
                            <div class="space" v-if="index < bannerData.length-1"></div>
                        </div>
                        </div>
                    <div class="right poiter"  @click="JumpFn('预约私教 抢占名额')">
                        预约私教 抢占名额
                    </div>
                </div>
                <div class="t-1 center-wrap">
                    <p class="flex title-flex">
                        <img src="https://s20.lgstatic.com/growth/activity/20211129/1638187748929.png" class="title-icon"> 
                        <span class="title-m">为什么要选择 NEXT 计划?</span>
                        <img src="https://s20.lgstatic.com/growth/activity/20211129/1638187889170.png" class="title-icon">
                    </p>
                    <div class="bg-1 flex">
                        <div class="left">
                            <div class="l-t">NEXT计划</div>
                            <div class="l-d">
                                <p><span class="ls"></span>真实<span>大厂在职技术专家</span>深度直播带教</p>
                                <p><span class="ls"></span>从金字塔模型出发设计<span>全面体系化的进阶内容</span></p>
                                <p><span class="ls"></span>根据学员个人情况，<span>量身定制学习计划</span></p>
                                <p><span class="ls"></span>求职导向，<span>承诺涨薪；</span>结果保证，签订协议</p>
                            </div>
                        </div>
                        <div class="right">
                            <div class="r-t">传统培训</div>
                            <div class="r-d">
                                <p><span class="ls"></span>脱离一线的全职讲师，填鸭式教学</p>
                                <p><span class="ls"></span>知识点堆砌，教学计划盲目</p>
                                <p><span class="ls"></span>无专业平台背书，不保结果</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="section section_3" id="section_3">
            <img class="se-img"  v-lazy="PCimglist[2].url">
             <div class="content">
                <div class="flex learn-wrap center-wrap">
                    <div class="left flex-1 flex">
                        <div class="l-t"><span class="ls"></span> <p>告别填鸭式教育，GET正确“学习金字塔”模式</p></div>
                        <div class="l-d">
                            <p>这些学习方式中，教别人（90%）、实践（75%）、小组讨论（50%）这三种更有助于有效掌握学习内容。</p>
                             <p style="font-weight:500">NEXT 计划的学习模式，就是围绕这三种方式设计的。</p>
                        </div>
                    </div>
                     <div class="right">
                     </div>
                </div>
            </div>
        </div>
        <div class="section section_4" id="section_4">
            <img class="se-img" src="https://s20.lgstatic.com/growth/activity/20211129/1638195854004.png">
             <div class="content">
                <div class="t-1 center-wrap">
                    <img src="https://s20.lgstatic.com/growth/activity/20211127/1638004790288.png" alt="" class="tip-icon">
                    <p class="title-m">选择 NEXT 计划</p>
                    <p class="title-m">找一个 P7+ 在职前端技术专家</p>
                    <div class="t-1-d">
                        16 周带你领先一步涨薪进大厂
                    </div>
                    <div class="plan-wrap flex">
                        <div class="left"></div>
                        <div class="right flex-1">
                            <div class="top">
                                <p class="flex"><span class="ls"></span><span>P7+在职技术专家、架构师</span>，平均从业经验6年以上；</p>
                                <p class="flex"><span class="ls"></span>来自<span>阿里、腾讯、字节等一线大厂</span>，丰富的大厂项目落地经验；</p>
                                <p class="flex"><span class="ls"></span>多年面试官，<span>熟知大厂用人规则</span>，带教经验丰富。</p>
                            </div>
                            <div class="bottom">
                                <div class="l-t flex"><span class="ls"></span><span>五重身份，全方位助力涨薪</span></div>
                                    <div class="l-d">
                                        <div class="ld-icon">
                                            <img src="https://s21.lgstatic.com/growth/activity/20211130/1638253645408.png" alt="">
                                        </div>
                                        <div class="ld-des flex">
                                            <div class="des-item">诊断问题</div>
                                            <div class="des-item">指出盲区</div>
                                            <div class="des-item">启发思考</div>
                                            <div class="des-item">针对性教学</div>
                                            <div class="des-item">权威点评</div>
                                        </div>
                                    </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="section-swmain section-teacher section section_5" id="section_5">
            <!-- 轮播 -->
            <div class="sw-section">
                <div class="swiper-container wrap" id="sw-wrap">
                    <div class="swiper-wrapper">
                        <div v-for="item in PCSwiperList1"  class="swiper-slide" :key="item" 
                        >
                            <img :src="item.url" >
                        <div class="s-text">
                            <div class="top flex">
                                <img src="https://s20.lgstatic.com/growth/activity/20211130/1638266609363.png" alt="头像" class="head-icon">
                                <p>{{item.name}}</p>
                                <p class="spaceY"></p>
                                <p class="flex-1">{{item.title}}</p>
                            </div>
                            <div class="bottom flex">
                                <li  v-for="de in item.des" :key="de"><span class="poit"></span><span v-html="de"></span></li>
                            </div>
                        </div>
                        </div>
                    </div>
                    <div class="swiper-pagination sw-pagination" />
                    <div class="swiper-button-next"></div>
                    <div class="swiper-button-prev"></div>
                </div>
                 <button class="jump-btn-teacher poiter flex" @click="JumpFn('查看更多教练信息')">
                     <span>查看更多教练信息</span>
                     <img src="https://s21.lgstatic.com/growth/activity/20211128/1638078881128.png?x-oss-process=style/80" alt="">
                    <!-- <img src="https://s20.lgstatic.com/growth/activity/20211124/1637743017769.png"> -->
                </button>
            </div>
        </div>
        <div class="section section_6 " id="section_6">
            <img class="se-img"  v-lazy="PCimglist[3].url">
             <div class="content">
                <div class="t-1 center-wrap progress-wrap">
                    <p class="flex title-flex">
                        <img src="https://s20.lgstatic.com/growth/activity/20211129/1638187748929.png" class="title-icon"> 
                        <span class="title-m">量身定制学习计划 六大阶段冲击高薪大厂</span>
                        <img src="https://s20.lgstatic.com/growth/activity/20211129/1638187889170.png" class="title-icon">
                    </p>
                    <div class="p-c flex">
                        <div class="left flex">
                            <div class="l-item flex-1">准备阶段</div>
                            <div class="l-item flex-1">提升阶段</div>
                            <div class="l-item special flex-1">跳槽阶段</div>
                        </div>
                        <div class="right flex-1">
                            <div class="p-t flex">
                                <div class="p-t-item flex-1">
                                    <img src="https://s21.lgstatic.com/growth/activity/20211129/1638192965818.png" alt="" class="p-t-icon">
                                    <div class="p-t-top">
                                        私教1v1能力测评
                                    </div>
                                    <div class="p-t-bottom">
                                        结合大厂用人标准，出具能力诊断报告。全方位了解自身能力；
                                    </div>
                                </div>
                                <div class="p-t-item flex-1 p-t-item2">
                                    <img src="https://s21.lgstatic.com/growth/activity/20211129/1638192978445.png" alt="" class="p-t-icon">
                                    <div class="p-t-top">
                                        量身定制学习计划
                                    </div>
                                    <div class="p-t-bottom">
                                        专属私人定制化，量体裁衣，对症下药，技术提升加速器
                                    </div>
                                </div>
                            </div>
                            <div class="p-slide flex">
                                <div v-for="(item,index) in progressData" :key="index" class="p-slide-item flex-1">
                                    <div class="p-slide-title flex">
                                        <div class="p-top">阶段{{item.idDes}}</div>
                                        <div class="p-bottom">{{item.title}}</div>
                                    </div>
                                    <div class="p-slide-des">
                                        <p v-for="(des,deId) in item.des" :key="deId">{{des}}</p>
                                        <img :src="item.icon" alt="" class="p-slide-icon">
                                    </div>
                                </div>
                            </div>
                            <div class="p-sevice flex">
                                <div class="p-sevice-item flex-1 flex">
                                    <div class="p-sevice-top">职业辅导</div>
                                    <div class="p-sevice-bottom">手把手简历修改、明晰职业规划、定位自身发展</div>
                                </div>
                                <div class="p-sevice-item flex-1 flex">
                                    <div class="p-sevice-top">内推大厂*</div>
                                    <div class="p-sevice-bottom">教练直接内推、直通大厂、百家企业可供选择</div>
                                </div>
                                <div class="p-sevice-item flex-1 flex">
                                    <div class="p-sevice-top">面试陪跑</div>
                                    <div class="p-sevice-bottom">提升求职技能、复盘面试、冲击大厂</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="section" id="section_learn">
            <div class="content">
                <div class="t-1 center-wrap">
                    <p class="flex title-flex">
                        <img src="https://s20.lgstatic.com/growth/activity/20211129/1638189903001.png" class="title-icon"> 
                        <span class="title-m" style="color:#fff">八大体系内容 基于企业需求研发设计</span>
                        <img src="https://s20.lgstatic.com/growth/activity/20211129/1638189916614.png" class="title-icon">
                    </p>
                    <p class="title-des">全面涵盖前端进阶必备技术</p>
                </div>
            </div>
            <img class="se-img"  v-lazy="PCimglist[4].url" alt="">
        </div>
        <div class="sectione-main section" id="section_main">
            <div class="main">
                <el-tabs v-model="activeName" @tab-click="changeTabs">
                    <el-tab-pane class="main-tab"
                        v-for="(item, index) in stageList" :key="index" 
                        :label="item.stage" :name="index"
                    >
                        <div class="m">
                            <div class="m-title">
                                <div>{{item.title}}</div>
                                <div class="btn flex flex-center poiter" @click="seeDetail(item)">
                                    <div>详情</div>
                                    <img src="https://s21.lgstatic.com/growth/activity/20211130/1638257399948.png" alt="">
                                </div>
                            </div>
                            <div class="main-t flex">
                                <div class="m-b">
                                    学习目标
                                </div>
                                <div class="m-c">
                                    <div class="item" v-for="(v, i) in item.phaseTargetList" :key="i" > {{i+1}}.{{v}}</div>
                                </div>
                            </div>
                            <div class="main-t flex">
                                <div class="m-b">
                                    关键技术点
                                </div>
                                <div class="m-c">
                                <div class="item" v-for="(v, i) in item.skillsList" :key="i" > {{i+1}}.{{v}}</div>
                                </div>
                            </div>
                        </div>
                    </el-tab-pane>
                </el-tabs>
                <div class="modal" v-if="showModal">
                    <div @click="close" class="close poiter"></div>
                    <div v-for="(item, index) in showData.details" :key="index">
                        <div class="modal-title">
                            {{item.t}}
                        </div>
                        <div class="modal-desc" v-for="(i, is) in item.desc" :key="is">
                            {{i}}
                        </div>
                    </div>
                </div>
                <button class="jump-btn poiter flex flex-center" @click="JumpFn('领取完整课程安排')">
                    <div class="p-content-btn poiter">领取完整课程安排</div>
                    <img src="https://s20.lgstatic.com/growth/activity/20211130/1638257909575.png" alt="" class="p-content-btn-img">
                </button>
            </div>
        </div>
        <div class="section-swmain section-program section" id="section-program">
            <div class="content">
                <div class="t-1 center-wrap swiper-content">
                    <p class="flex title-flex">
                        <img src="https://s20.lgstatic.com/growth/activity/20211129/1638187748929.png" class="title-icon"> 
                        <span class="title-m">往期大厂项目实战 由私教全程设计跟踪</span>
                        <img src="https://s20.lgstatic.com/growth/activity/20211129/1638187889170.png" class="title-icon">
                    </p>
                    <p class="des-title">掌握大厂业务研发工作全流程</p>
                    
                    <div class="sw-section">
                        <div class="swiper-container wrap" id="pr-wrap">
                            <div class="swiper-wrapper poiter">
                                <div v-for="(item,index) in PCSwiperList2"  class="swiper-slide" :key="index">
                                   <div class="p-name">{{item.name}}</div>
                                   <div class="flex p-content-container">
                                        <div class="p-content">
                                            <div class="p-content-wrap"> 
                                                    <div class="p-content-title">
                                                        <img src="https://s20.lgstatic.com/growth/activity/20211129/1638166900472.png" alt=""> 项目介绍:</div>
                                                    <div class="p-content-des sub-title">{{item.des}}</div>
                                            </div>
                                            <div class="p-content-wrap"> 
                                                    <div class="p-content-title">
                                                        <img src="https://s20.lgstatic.com/growth/activity/20211129/1638166900472.png" alt=""> 项目核心介绍:</div>
                                                    <div class="p-content-skill sub-title" v-for="(s,sId) in item.skillList" :key="sId">
                                                        <div class="flex p-content-main">
                                                            <span class="p-content-circle"></span>
                                                            <span class="p-content-word">{{s.title}}</span>
                                                        </div>
                                                        <div v-if="s.child" class="p-content-child flex">
                                                            <span class="p-content-child-item" v-for="(c,cId) in s.child" :key="cId">{{c}}</span>
                                                        </div>
                                                    </div>
                                            </div>
                                            <div class="flex flex-center p-btn-wrap poiter"  @click="JumpFn('查看最新私教项目')">
                                                <div class="p-content-btn poiter">查看最新私教项目</div>
                                                <img src="https://s21.lgstatic.com/growth/activity/20211128/1638078881128.png" alt="" class="p-content-btn-img">
                                            </div>
                                        </div>
                                        <img :src="item.img" alt="" class="p-img">
                                   </div>
                                </div>
                            </div>
                            <div class="swiper-pagination sw-pagination" />
                            <div class="swiper-button-next"></div>
                            <div class="swiper-button-prev"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="section section_7" id="section_7">
            <div class="content">
                <div class="t-1 center-wrap private-wrap">
                    <p class="flex title-flex">
                        <img src="https://s20.lgstatic.com/growth/activity/20211129/1638187748929.png" class="title-icon"> 
                        <span class="title-m">往期技术进阶内容 由私教私人定制</span>
                        <img src="https://s20.lgstatic.com/growth/activity/20211129/1638187889170.png" class="title-icon">
                    </p>
                    <p class="s-title">前沿技术趋势一网打尽</p>
                    <div class="private-img"></div>
                </div>
            </div>
        </div>
        <div class="section section_8" id="section_8">
            <div class="content">
                <div class="t-1 center-wrap planning-wrap">
                      <p class="flex title-flex">
                        <img src="https://s20.lgstatic.com/growth/activity/20211129/1638187748929.png" class="title-icon"> 
                        <span class="title-m">从技术提升到求职面试  全程贴心陪伴</span>
                        <img src="https://s20.lgstatic.com/growth/activity/20211129/1638187889170.png" class="title-icon">
                    </p>
                    <div class="planning-content flex">
                        <div class="planning-item flex-1" v-for="(item,index) in planData" :key="index">
                            <div class="top flex">
                                <img :src="item.icon" alt="">
                                <span>{{item.title}}</span>
                            </div>
                            <div class="bottom flex">
                                <div class="b-item flex" v-for="(de,deId) in item.des" :key="deId">
                                    <span class="circle"></span>
                                    <span class="left">{{de.left}}：</span>
                                    <span class="right">{{de.right}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="section section_9" id="section_9">
            <div class="content">
                <div class="t-1 center-wrap company-wrap">
                    <p class="flex title-flex">
                        <img src="https://s20.lgstatic.com/growth/activity/20211129/1638189903001.png" class="title-icon"> 
                        <span class="title-m" style="color:#fff">拉勾有品牌  百家名企深度合作</span>
                        <img src="https://s20.lgstatic.com/growth/activity/20211129/1638189916614.png" class="title-icon">
                    </p>
                    <div class="company-content flex">
                        <div class="left flex">
                            <div class="l-item flex">
                                <div class="top">
                                    <img src="https://s20.lgstatic.com/growth/activity/20211129/1638174862817.png" alt="">
                                    <div class="title">互联网企业</div>
                                </div>
                                <div class="bottom flex-1 flex">
                                    <p class="b-title">入驻拉勾</p>
                                    <p class="b-des">（包括头部一线大厂）</p>
                                </div>
                            </div>
                            <div class="l-item flex">
                                <div class="top">
                                    <img src="https://s21.lgstatic.com/growth/activity/20211129/1638174889386.png" alt="">
                                    <div class="title">互联网企业</div>
                                </div>
                                <div class="bottom flex-1 flex">
                                    <p class="b-title">使用拉勾找工作</p>
                                </div>
                            </div>
                            <div class="l-item flex">
                                <div class="top">
                                    <img src="https://s21.lgstatic.com/growth/activity/20211129/1638174903202.png" alt="">
                                    <div class="title">企业定向内推</div>
                                </div>
                                <div class="bottom flex-1 flex">
                                    <p class="b-title">学员直通企业</p>
                                </div>
                            </div>
                        </div>
                        <div class="right">
                            <img src="https://s20.lgstatic.com/growth/activity/20211129/1638175962316.png" alt="">
                        </div>
                    </div>
                    <button class="company-btn flex poiter" @click="JumpFn('点击查看详细企业名单')">
                        <p>点击查看详细企业名单</p>
                        <img src="https://s20.lgstatic.com/growth/activity/20211129/1638176604086.png" alt="">
                    </button>
                </div>
            </div>
        </div>
        <div class="section section_10" id="section_10">
            <div class="content">
                <div class="t-1 center-wrap student-wrap">
                    <p class="flex title-flex">
                        <img src="https://s20.lgstatic.com/growth/activity/20211129/1638187748929.png" class="title-icon"> 
                        <span class="title-m">产品有口碑 万名学员捷报频传</span>
                        <img src="https://s20.lgstatic.com/growth/activity/20211129/1638187889170.png" class="title-icon">
                    </p>
                    <div class="s-title flex flex-center">
                        <div class="s-title-item flex">
                            <img src="https://s21.lgstatic.com/growth/activity/20211129/1638177514746.png" alt="">
                            <div class="des">学员口碑作证</div>
                        </div>
                        <div class="s-title-item flex">
                            <img src="https://s21.lgstatic.com/growth/activity/20211129/1638177533765.png" alt="">
                            <div class="des">学员达成协议</div>
                        </div>
                        <div class="s-title-item flex">
                            <img src="https://s21.lgstatic.com/growth/activity/20211129/1638177546581.png" alt="">
                            <div class="des">学员进入超一线大厂</div>
                        </div>
                        <div class="s-title-item flex">
                            <img src="https://s20.lgstatic.com/growth/activity/20211129/1638177560484.png" alt="">
                            <div class="des">学员薪水涨幅超过50%</div>
                        </div>
                    </div>
                    <div class="student-content">
                        <div class="student-content-item" v-for="(item,index) in sudentData" :key="index">
                            <div class="top flex">
                                <img :src="item.icon" alt="">
                                <div class="info">
                                    <div class="info-m flex">{{item.name}}<span class="spaceY"></span>{{item.workYear}}</div>
                                    <div class="info-k">关键词：<span>{{item.keyWord}}</span></div>
                                </div>
                            </div>
                            <div class="bottom">
                                {{item.detail}}
                            </div>
                        </div>
                    </div>
                    <div class="tips">
                        *“内推”、“直推”、“就业推荐”等服务需满足一定考核条件，详见《学员协议》
                    </div>
                </div>
            </div>
        </div>
        <div class="ceiling-view flex section" :class="{'ceiling-fixed':ceilingType}" v-if="ceilingType">
            <div class="content flex">
                <div class="ceiling-tab">
                    <div class="tab-item" 
                        v-for="(item, index) in tabList" :key="index" 
                        :class="{'active-tab': activeTab === index}"
                        @click="changeTab(item,index)"
                    >
                        <span>{{item.stage}}</span>
                        <div v-if="activeTab === index" class="bor" />
                    </div>
                </div>
                <div class="jump-wrap flex">
                    <div class="left flex pay-type">
                        <div class="title">轻松入学无负担</div>
                        <div class="sub-title flex">
                            <div class="item flex flex-center">
                                <img src="https://s21.lgstatic.com/growth/activity/20211129/1638184549389.png?x-oss-process=style/80" alt="">
                                <span>支持信用卡分期</span>
                            </div>
                            <div class="item flex flex-center">
                                <img src="https://s21.lgstatic.com/growth/activity/20211129/1638184549389.png?x-oss-process=style/80" alt="">
                                <span>0手续费</span>
                            </div>
                            <div class="item flex flex-center">
                                <img src="https://s21.lgstatic.com/growth/activity/20211129/1638184549389.png?x-oss-process=style/80" alt="">
                                <span>0利息</span>
                            </div>
                        </div>
                    </div>
                    <div class="right pay-btn" @click="JumpFn('预约私教 抢占名额')">
                        预约私教
                    </div>
                    <!-- <img src="https://s20.lgstatic.com/growth/activity/20211124/1637737947143.png" alt="" class="pay-type">
                    <img src="https://s21.lgstatic.com/growth/activity/20211124/1637738179788.png" alt=""  class="pay-btn poiter" @click="JumpFn('预约私教 抢占名额')"> -->
                </div>
            </div>
        </div>
        <div class="tab-icon flex" v-if="ceilingType">
            <div class="flex-1 top-bg">
                <div class="zixun item" @click="JumpFn('咨询')">
                    <img src="https://s20.lgstatic.com/growth/activity/20211124/1637746059561.png" alt="">
                    <p>咨询</p>
                </div>
                <div class="learn item" @click="JumpFn('试学')">
                    <img src="https://s20.lgstatic.com/growth/activity/20211124/1637746081221.png" alt="">
                    <p>试学</p>
                </div>
                <div class="buy item" @click="JumpFn('领券')">
                    <img src="https://s21.lgstatic.com/growth/activity/20211124/1637746098200.png" alt="">
                    <p>领券</p>
                </div>
            </div>
            <div class="toTop flex" @click="toTop">
                <img src="https://s21.lgstatic.com/growth/activity/20211124/1637746762876.png" alt="">
                <p>顶部</p>
            </div>
        </div>
    </div>
</template>

<script>
import { handleJumpUrl } from '../../../uitl/getParam.js';
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.css';
import activity from '../../../common/activity';
import List from './data.js'
import mixin from '../../../common/js/mixins/repurchase'

    export default {
        mixins: [mixin],
        data() {
            return {
                activity,
                List:List,
                SI: 0,
                PCimglist: [
                    {url:"https://s21.lgstatic.com/growth/activity/20211130/1638252132752.png",type:"img"},
                    {url:"https://s20.lgstatic.com/growth/activity/20211127/1637997009264.png",type:"img"},
                    {url:"https://s21.lgstatic.com/growth/activity/20211127/1638001505845.png",type:"img"},
                    {url:"https://s20.lgstatic.com/growth/activity/20211128/1638103019582.png",type:"img"},
                    {url:"https://s20.lgstatic.com/growth/activity/20211129/1638188555561.png",type:"img"},
                    
                ],
                PCSwiperList1:[
                    {
                        url:"https://s21.lgstatic.com/growth/activity/20211129/1638187494300.png",
                        title:"前端架构师",
                        name:"本",
                        des:[
                            "曾就职<span style='color:#FFE88E'>百度、快手</span>，担任前端负责人或前端架",
                            "从 0 到 1 搭建多个<span style='color:#FFE88E'>企业级项目</span>（基于浏览器/ pc 等不同端场景）",
                            "<span style='color:#FFE88E'>多年面试官经验</span>，有效识别前端开发技术水平"
                        ]
                    },
                    {
                        url:"https://s21.lgstatic.com/growth/activity/20211129/1638187521562.png",
                        title:"资深前端架构师",
                        name:"伯约",
                        des:[
                            "擅长企业级前端应用架构与性能治理",
                            "主导大厂<span style='color:#FFE88E'>事业部级</span>的前端基建服务建设，支撑着多个 BU 的前端中台技术开发",
                            "拥有丰富的面试官经验，<span style='color:#FFE88E'>熟知大厂选人规则</span>"
                        ]
                    },
                    {
                        url:"https://s21.lgstatic.com/growth/activity/20211129/1638187494300.png",
                        title:"前端技术专家",
                        name:"WY",
                        des:[
                           "曾任百度资深前端工程师，某五百强企业<span style='color:#FFE88E'>中台可视化负责人</span>",
                            "有丰富的全栈项目架构背景",
                            "在前端性能调优、SEO及前端可视化等方向有丰富实战经验"
                        ]
                    },
                    {
                        url:"https://s21.lgstatic.com/growth/activity/20211129/1638187521562.png",
                        title:"高级前端专家",
                        name:"波波",
                        des:[
                            "曾就职<span style='color:#FFE88E'>携程、腾讯</span>等公司，任多家企业的前端项目负责人",
                            "有丰富的工程化和架构经验，精通<span style='color:#FFE88E'>框架源码</span>",
                            "擅长性能调优",
                            "能给学员带来全新的<span style='color:#FFE88E'>技术成长和思维方式</span>"
                        ]
                    },
                    {
                        url:"https://s21.lgstatic.com/growth/activity/20211129/1638187494300.png",
                        title:"前端架构师",
                        name:"梅子",
                        des:[
                            "曾任<span style='color:#FFE88E'>网易、阿里前端架构师</span>，制定了多个项目<span style='color:#FFE88E'>前端规范</span>",
                            "擅长流行框架和组件库搭建，帮助突破基础技术重难点",
                            "<span style='color:#FFE88E'>丰富带新人经验</span>，注重程序员潜能挖掘，提供科学有效的面试训练"
                        ]
                    },
                ],
                PCSwiperList2:[
                    // "https://s21.lgstatic.com/growth/activity/20211125/1637811242354.png",
                    // "https://s20.lgstatic.com/growth/activity/20211125/1637811264147.png",
                    // "https://s20.lgstatic.com/growth/activity/20211125/1637811272793.png"
                    {
                        name:"百度某项目微前端改造",
                        des:"基于大型团队同一业务线的开发协作场景，进行微前端架构改造。",
                        skillList:[
                                {title:"中心化方案",child:["应用注册系统","跨域解决方案"]},
                                {title:"去中心化方案",child:["物料注册发布系统","工程脚手架"]}
                        ],
                        img:"https://s21.lgstatic.com/growth/activity/20211130/1638271144471.png?x-oss-process=style/80"
                   },
                    {
                        name:"阿里巴巴某 APP 前端性能优化实战",
                        des:"在用户不断增多的场景下，对大型项目进行性能检测与再调优。",
                        skillList:[
                                {title:"搭建性能监控预警平台"},
                                {title:"性能问题"},
                                {title:"大型项目必备的性能优化方式"},
                                {title:"数据监测"}
                        ],
                        img:"https://s20.lgstatic.com/growth/activity/20211130/1638271128579.png?x-oss-process=style/80"
                       
                   },
                    {
                        name:"快手某数据可视化项目",
                        des:"为直播销售场景提供数据可视化支持，助力商家进行营销数据监控。",
                        skillList:[
                                {title:" 主流可视化方案剖析"},
                                {title:"落地实现细节"},
                                {title:" 图表定制化改造"},
                                {title:"高并发场景下的数据可视化"}
                        ],
                        img:"https://s20.lgstatic.com/growth/activity/20211130/1638271021023.png?x-oss-process=style/80"
                       
                   }
                ],
                stageList:[],
                bannerData:[],
                courseId: 38,
                currTouchIndex:0,
                tabList:[],
                ceilingType:false,
                activeTab:0,
                showModal:false,
                progressData:[
                    {
                        idDes:"一",
                        title:'底层技术加强',
                        des:['梳理前端技术脉络' ,'全面提升编程能力'],
                        icon:"https://s21.lgstatic.com/growth/activity/20211129/1638155912964.png"
                    },
                    {
                        idDes:"二",
                        title:'框架原理剖析',
                        des:['精通前端框架实战技巧' ,'探索框架原理源码'],
                        icon:"https://s21.lgstatic.com/growth/activity/20211129/1638155934068.png"
                    },
                    {
                        idDes:"三",
                        title:'大厂项目带练',
                        des:['真实大厂项目实战演练' ,'复现大厂真实开发流程'],
                        icon:"https://s21.lgstatic.com/growth/activity/20211129/1638155951046.png"
                    },
                    {
                        idDes:"四",
                        title:'重塑项目经验',
                        des:['私教指导学员梳理项目' ,'以大厂思维重塑认知'],
                        icon:"https://s20.lgstatic.com/growth/activity/20211129/1638155967063.png"
                    },
                    {
                        idDes:"五",
                        title:'技术视野拓展',
                        des:['私教开启高质量讲座' ,'分享前沿技术趋势'],
                        icon:"https://s20.lgstatic.com/growth/activity/20211129/1638155985518.png"
                    },
                    {
                        idDes:"六",
                        title:'求职冲刺',
                        des:['大厂面试官模拟面试' ,'求职冲刺斩获Offer'],
                        icon:"https://s21.lgstatic.com/growth/activity/20211129/1638155999899.png?x-oss-process=style/80"
                    },

                ],
                planData:[
                    {
                        icon:'https://s21.lgstatic.com/growth/activity/20211129/1638173065450.png',
                        title:'学习辅导',
                        des:[
                            {
                                left:'全面答疑',
                                right:'私教集中答疑，导师实时在线'
                            },
                            {
                                left:'1V1辅导',
                                right:'技术难点讲解，作业返修，精细化建议'
                            },
                             {
                                left:'技术支持',
                                right:'为工作难题提供解决方案'
                            }
                        ]
                    },
                    {
                        icon:'https://s21.lgstatic.com/growth/activity/20211129/1638173092108.png?x-oss-process=style/80',
                        title:'小班督学',
                        des:[
                            {
                                left:'社群提醒',
                                right:'班主任深度追踪学习进度'
                            },
                            {
                                left:'学习档案',
                                right:'监测技术成长，动态调整学习重点'
                            },
                             {
                                left:'小班氛围',
                                right:'为工作难题提供解决方案'
                            }
                        ]
                    },
                     {
                        icon:'https://s20.lgstatic.com/growth/activity/20211129/1638173105351.png?x-oss-process=style/80',
                        title:'求职规划',
                        des:[
                            {
                                left:'简历修改',
                                right:'打造符合岗位需求的简历内容'
                            },
                            {
                                left:'模拟面试',
                                right:'提前演练，随时复盘，锻炼面试表达'
                            },
                             {
                                left:'内推大厂',
                                right:'心仪岗位，直接内推业务方'
                            }
                        ]
                    },
                ],
                sudentData:[
                    {
                        icon:'https://s20.lgstatic.com/growth/activity/20211129/1638180874932.png?x-oss-process=style/80',
                        name:'李同学',
                        workYear:'2年工作经验',
                        keyWord:'薪资翻倍',
                        detail:'入班不到3个月，我就出去面试了，拿到了一家金融公司的offer，薪资直接翻番！教练讲过的面试题目很全，我之前回答不出来的问题，现在轻轻松松解答，面试越来越有自信。非常感谢私教，班级氛围特别好，现在看回放心态都不一样了，学的更猛了！'
                    },
                    {
                        icon:'https://s20.lgstatic.com/growth/activity/20211129/1638181486398.png?x-oss-process=style/80',
                        name:'王同学',
                        workYear:'3年工作经验',
                        keyWord:'大厂Offer',
                        detail:'我是传统企业出身，用的技术栈都相对比较陈旧，于是毫不犹豫选择了报班学习。面试刚开始试水我就收获了多家offer，最终选择了字节，也实现了大幅涨薪，涨幅105%，接下来继续努力~'
                    },
                    {
                        icon:'https://s21.lgstatic.com/growth/activity/20211129/1638181563903.png?x-oss-process=style/80',
                        name:'陈同学',
                        workYear:'5年工作经验',
                        keyWord:'晋升管理',
                        detail:'学习过程中私教跟我说可以尝试走技术管理的方向，跳槽之前薪资20K左右，现在30*14，涨幅50%，感谢拉勾教育给了自己当一个技术leader的底气，让自己能够有足够的技术底子去尝试往上走。'
                    },
                    {
                        icon:'https://s20.lgstatic.com/growth/activity/20211129/1638181575325.png?x-oss-process=style/80',
                        name:'邓同学',
                        workYear:'移动开发',
                        keyWord:'海外涨薪',
                        detail:'Base海外，为了跳槽选择了拉勾。在加入之前和蚂蚁的朋友确认过，确实可以达到P7的标准，内容非常丰富，学习流程设计也很科学。现在我已经成功入职新公司了，薪资涨幅很满意，对我帮助超级大，我还会继续坚持学习的！'
                    },
                    {
                        icon:'https://s20.lgstatic.com/growth/activity/20211129/1638181593175.png?x-oss-process=style/80',
                        name:'石同学',
                        workYear:'应届生',
                        keyWord:'多家Offer',
                        detail:'大学上课老摸鱼，因此我的基础不是很好，毕业前开始焦虑，多番对比后选择了拉勾。面试的时候非常有底气，拿了多家offer，但是还是想努力冲刺下大厂，明年再接再厉！'
                    },
                     {
                        icon:'https://s21.lgstatic.com/growth/activity/20211129/1638181633206.png?x-oss-process=style/80',
                        name:'刘同学',
                        workYear:'3年工作经验',
                        keyWord:'跳出外包',
                        detail:'做过外包的人都知道那是什么感受，我不想再当工具人了。在面试之前我决定认真提升自己，加入NEXT计划是我做的最棒的决定。投简历的时候我就拿到了好多面试机会，经过面试后我拿到了一家小厂的offer，成功跳出了外包圈，涨幅也达到了53%！'
                    }
                ]
            }
        },
        computed: {
            currentStage() {
                return this.stageList[this.SI] || {};
            },
        },
        created () {
            setTimeout(()=>{
                this.eduPlatTrack('WebView', { page_id: 'g1tdr'});
            },500)
            
            let dataList = this.List.data
            this.stageList = dataList.stageList
            this.bannerData= dataList.bannerData
        },
        mounted () {
            let dataList = this.List.data;
            const {tabList} = dataList;
            this.tabList = tabList;;
            window.addEventListener('scroll', this.scrollTopFn)
            this.renderSwiper();
            this.renderSwiper1();
        },
        destroyed () {
            window.removeEventListener('scroll', this.scrollTopFn)
        },
        methods: {
            changeTab(item,index) {
                this.activeTab = index
                let arr = [
                    "#section_4",
                    "#section_6",
                    "#section_learn",
                    "#section_8",
                ]
                this.$el.querySelector(arr[index]).scrollIntoView(true);
                let scroll = document.documentElement.scrollTop || document.body.scrollTop;
                document.documentElement.scrollTop = scroll - 100
                document.body.scrollTop = scroll - 100
                this.eduPlatTrack('WebButtonClick', {
                    'page_id': 'g1tdr',
                    'button_name': item.stage
                });
            },
            scrollTopFn() {
                let scroll = document.documentElement.scrollTop || document.body.scrollTop;
                this.ceilingType = scroll > 550 ? true : false; //吸顶tab
                let arr = [
                    "section_4",
                    "section_6",
                    "section_learn",
                    "section_8",
                ]
                arr.forEach((item,index) =>{
                    if(document.getElementById(item).getBoundingClientRect().top < 200) {
                        this.activeTab = index
                    }
                })
            },
            changeLearnProblem(index){
                this.currTouchIndex = index;
            },
            mouseOver(index){
                this.currTouchIndex = index;
            },
            mouseLeave(){
                // this.currTouchIndex = 0;
            },
            JumpFn(name) {
                this.eduPlatTrack('WebButtonClick', {
                    'page_id': 'g1tdr',
                    'button_name': name,
                });
                setTimeout(() => {
                     handleJumpUrl(`60424ceaa6ca449983ec6b88cb4ab337`);
                }, 200);
            },
            renderSwiper() {
                setTimeout(() => {
                    const swiper = new Swiper('#sw-wrap', {
                        autoplay: false,
                        direction: 'horizontal',
                        loop: true,
                        autoplayDisableOnInteraction: false,
                        slidesPerView: 3,
                        pagination: '.sw-pagination',
                        paginationClickable: true,
                        watchSlidesProgress: true,
                        slidesOffsetBefore:0,
                        slidesPerView: 'auto',
                        spaceBetween: 21,
                        prevButton: '.swiper-button-prev',
                        nextButton: '.swiper-button-next',
                        centeredSlides: true
                    });
                }, 50);
            },
            renderSwiper1() {
                let option = {
                    direction: 'horizontal',
                    loop: true,
                    speed: 500,
                    autoplayDisableOnInteraction: false,
                    autoplay: false,
                    pagination: '.sw-pagination',
                    paginationClickable: true,
                    prevButton: '.swiper-button-prev',
                    nextButton: '.swiper-button-next',
                    spaceBetween: 30
                };
                this.$nextTick(() => {
                    const swiper2 = new Swiper('#pr-wrap', option);
                });
            },
            seeDetail(val) {
                this.showModal = true;
                this.showData = val
                 this.eduPlatTrack('WebButtonClick', {
                    'page_id': 'g1tdr',
                    'button_name': '大纲详情',
                });
            },
            close() {
                this.showModal = false;
            },
            changeTabs(val) {
                this.showModal = false
            },
            toTop(){
                this.$el.querySelector('#section_1').scrollIntoView(true);
            }
        },
    }
</script>

<style lang="less" scoped>
.container-warp {
    *{
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    }
    @import './pc.less';
    width: 100%;
    // background: linear-gradient(180deg, #FFFFFF 0%, #F6F7F7 100%);
    // background-color: #f6f7f7;
    position: relative;
    overflow: hidden;
    .privity-offter{
        position: absolute;
        top: 0;
        right: 15%;
        object-fit: contain;
        width: 104PX;
        height: 133PX;
    }
    button{
        cursor: pointer;
    }
    .ceiling-view {
        width: 100%;
        padding: 5PX 0;
        background-color: #fff;
        align-items:center;
        justify-content: space-between;
        .ceiling-tab {
            height: 66PX;
            background-color: #fff;
            border-radius: 2PX;
            // box-shadow: 0PX 6PX 8PX 0PX rgba(214, 209, 250, 0.08);
            display: flex;
            align-items: center;
            cursor: pointer;

            // transform: scale(.7);
            .tab-item {
                position: relative;
                text-align: center;
                font-size: 20PX;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #32355C;
                height: 100%;
                line-height: 66PX;
                box-sizing: border-box;
                .bor {
                    position: absolute;
                    bottom: 10PX;
                    left: 50%;
                    transform: translate(-50%);
                    width: 36PX;
                    height: 3PX;
                    border-radius: 1PX;
                    background: linear-gradient(217deg, #FF8223 0%, #FFC227 100%);
                }
            }
            .tab-item:not(:first-child){
                margin-left: 50PX;
            }
            .active-tab {
                box-sizing: border-box;
                &::before{
                    content: '';
                    width: 24PX;
                    height: 24PX;
                    background-size: 100% 100%;
                    position: absolute;
                    left: 62PX;
                    top:50%;
                    transform: translateY(-50%);
                    transition-duration: 0.3s;
                }
            }

        }
        .jump-wrap{
            flex: 1;
            text-align: right;
            font-size: 18PX;
            color: #333;
            align-items: center;
            img{
                vertical-align: middle;
                width: 13PX;
                height: 12PX;
            }
            .title{
                align-items: end;
            }
            .sub-title{
                justify-content: flex-end;
                .item{
                    margin-left: 24PX;
                }
            }
            .left{
                flex: 1;
                flex-direction: column;
            }
            .pay-btn{
                width: 200PX;
                height: 50PX;
                line-height: 50PX;
                margin-left: 25PX;
                color: #fff;
                font-size: 18PX;
                background: url('https://s20.lgstatic.com/growth/activity/20211129/1638185693937.png')no-repeat;
                background-size: 100% 100%;
                text-align: center;
            }
            span{
                color: #ABABAB;
                font-size: 15PX;
                margin-left: 9PX;
            }
            
        }
        
    }
    .ceiling-fixed {
        position: fixed;
        top: 0;
        left: 50%;
        transform: translate(-50%);
        z-index: 30;
    }
    .drawbtn-wrap {
        width: 300PX;
        height: 150PX;
        position: absolute;
        bottom: 10%;
        right: 15%;
        display: flex;
    }
    .draw-btn{
        width: 45%;
        height: auto;
        cursor: pointer;
    }
    .draw-rightbtn{
        right: 0;
        bottom: 0;
    }
    .join-more{
        position: absolute;
        width: 300PX;
        height: 88PX;
        left: 33%;
        bottom: 45PX;
    }
}

.se-btn-1 {
    width: 100%;
    height: 88PX;
    background-position: center;
    background-repeat: no-repeat;
    background-size: auto;
    border: none;
    display: block;
    position: absolute;
    bottom: 10PX;
    background-color: #F4F4F4;
    cursor:pointer;
}
.concat{
    position: absolute;
    bottom: 30%;
}
.swiper-top{
    padding-top: 30PX;
    box-sizing: content-box;
}
.section-touch {
    width: 100%;
    min-width: 1232PX;
    overflow: hidden;
    position: relative;
    background-color: #F4F4F4;
    background-size: 100% 100%;
    .center {
        width: 462PX;
        margin: 0PX auto 60PX;
        position: relative;
        .touch-img {
            width: 462PX;
            height: 464PX;
            margin: 0 auto 6PX;
            background-position: center;
            background-repeat: no-repeat;
            background-size: 100% 100%;
        }
        .touch-item{
            width: 231PX;
            height: 231PX;
            float: left;
            position: relative;
        }
        .active-url{
            width: 336PX;
            height: 163PX;
            position: absolute;
        }
    }
}

.sectione-main {
        width: 100%;
        font-size: 0;
        position: relative;
        height: auto;
        // padding-bottom: 200PX;
        // background: url("https://s21.lgstatic.com/growth/activity/20211123/1637656698430.png") no-repeat;
        // background-size: contain;
        .main {
            position: relative;
            width: 1200PX;
            margin: 0 auto;
            border-radius: 16PX;
            background-color: #fff;
            top: -330PX;
    
            .tips-tab {
                font-size: 14PX;
                color: #666;
                position: absolute;
                bottom: 80PX;
                right: 60PX;
            }
            .m {
                width: 100%;
                box-sizing: border-box;
                padding: 0 30PX;
            }
            .m-title {
                padding-top: 20PX;
                font-size: 28PX;
                font-family: SourceHanSansSC-Medium, SourceHanSansSC;
                font-weight: 400;
                color: #3B3B47;
                text-align: center;
                margin-bottom: 40PX;
                position: relative;
                .btn {
                    border: 2PX solid #595A83;
                    width: 120PX;
                    height: 40PX;
                    border-radius: 25PX;
                    position: absolute;
                    right: 40PX;
                    top: 20PX;        
                    font-size: 18PX;
                    line-height: 40PX;
                }
                img{
                    vertical-align: middle;
                    width: 7PX;
                    height: 14PX;
                    margin-left: 9PX;
                }
            }
            .main-icon {
                width: 688PX;
                height: 2PX;
                display: block;
                margin: 8PX auto 0;
            }
            .main-t {
                width: 100%;
                align-items: center;
                justify-content: center;
                border-top: 2PX solid #FBFBFE;
                color: #666;
                .m-b {
                    width: 20%;
                    height: 46PX;
                    font-size: 20PX;
                    text-align: center;
                    line-height: 46PX;
                    border-radius: 50PX;
                }
                .m-c{
                    flex: 1;
                    border-left: 2PX solid #FBFBFE;
                    padding: 20PX 0;
                    text-align: left;
                }
                .detail {
                    display: block;
                    width: 132PX;
                    height: 48PX; 
                    float: right;
                }
            }
            .item {
                position: relative;
                font-size: 18PX;
                font-family: SourceHanSansSC-Light, SourceHanSansSC;
                margin: 10PX 20PX;
                padding-left: 15PX;
                color: #666;
                &::after {
                    position: absolute;
                    content: '';
                    left: 0PX;
                    top: 50%;
                    transform: translateY(-50%);
                    width: 6PX;
                    height: 6PX;
                    border-radius: 50%;
                }
            }
            .modal {
                position: absolute;
                top: 156PX;
                left: 50%;
                transform: translate(-50%);
                width: 900PX;
                border-radius: 20PX;
                background-color: #fefefe;
                box-shadow: 0px 2px 30px 0px rgba(65, 72, 120, 0.12);
                z-index: 999;
                border: 2PX solid #F6F7F7;
                box-sizing: border-box;
                padding: 20PX 50PX 40PX;
                text-align: left;
                .close {
                    position: absolute;
                    right: 40PX;
                    top: 40PX;
                    width: 24PX;
                    height: 24PX;
                    background: url('https://s21.lgstatic.com/growth/activity/20211130/1638243452579.png') no-repeat;
                    background-size: 100% 100%;
                    &:hover{
                        background: url('https://s21.lgstatic.com/growth/activity/20211130/1638243757936.png') no-repeat;
                        background-size: 100% 100%;  
                    }
                }
                .modal-title {
                    font-size: 20PX;
                    padding:35PX 0 10PX;
                    color: #666;
                }
                .modal-desc {
                    font-size: 14PX;
                    color: #666;
                    padding-left: 18PX;
                    margin-top:10PX;
                }
            }
            .jump-btn {
                position: absolute;
                left: 50%;
                transform: translate(-50%);
                bottom: -160PX;
                width: 408PX;
                height: 68PX;
                background-color:transparent;
                border: none;
                background: linear-gradient(217deg, #FF8223 0%, #FFC227 100%);
                box-shadow: 0PX 1PX 2PX 0PX rgba(255, 255, 255, 0.9);
                border-radius: 32PX;
                img {
                    width: 100%;
                    display: block;
                }
                .p-content-btn-img{
                    width: 23PX;
                    height: 32PX;
                    margin-left: 14PX;
                }
                .p-content-btn{
                    font-size: 24PX;
                    color: #fff;
                    text-align: center;
                    font-weight: 500;
                }
            }
        }
        /deep/ .el-tabs {
            width: 1200PX;
            margin: 0 auto;
            .el-tabs__header, .el-tabs__nav-wrap, .el-tabs__nav-scroll {
                border-top-left-radius: 16PX;
                border-top-right-radius: 16PX;
                background: #FAFBFD;
            }
            .el-tabs__nav-wrap{
                padding: 43PX 0 27PX 0;
            }
            .el-tabs__item {
                text-align: center;
                width: 170PX;
                height: 56PX;
                line-height: 56PX;
                padding: 0 30PX;
                font-size: 24PX;
                font-family: SourceHanSansSC-Regular, SourceHanSansSC;
                color: #3B3B47;
                font-weight: normal;
                border-radius: 47PX;
                margin: 0 10PX;

            }
            .el-tabs__nav-prev, .el-tabs__nav-next {
                top: 50%;
                color: #ff663e;
                font-weight: 500;
                font-size: 34PX;
                transform: translateY(-50%);
                position: absolute;
                z-index: 11;
            }
            .el-tabs__nav-wrap.is-scrollable {
                padding: 20PX 40PX 20PX 40PX;
                // padding: 0 35PX;
            }
            .el-tabs__nav-wrap::after{
                background-color:transparent;
            }
            .el-tabs__active-bar {
                background-color: transparent;
            }
            .el-tabs__item.is-active {
                color: #fff;
                font-weight: bold;
                font-size: 25PX;
                background: linear-gradient(151deg, #FF9565 0%, #FF291C 100%);
            }
        }
        &::before{
            clear: both;
            content: "";
        }
    }
.mg-s {
    margin-top: -5PX;
}
.sw-section {
    width: 100%;
    // padding: 30PX 0 30PX;
    position: relative;
    /deep/ .wrap {
        height: 380PX;
        width: 1200PX;
        position: relative;
        margin:  0 auto;
        .swiper-slide {
            width: 1200PX;
            opacity: 0;
            position: relative;
            img {
                display: block;
                width: 382PX;
                height: 297PX;
                margin: 0 auto;
                object-fit: contain;
            }
            &.swiper-slide-active {
                opacity: 1;
            }
            &.swiper-slide-next, &.swiper-slide-prev {
                opacity: 1;
            }
        }
        .swiper-pagination-bullet{
            width: 10PX;
            height: 10PX;
            background:  #70CA92;
            border-radius: 50%;
            opacity: .5;
            &-active{
                opacity: 1;
                border-radius: 10PX;
                width: 22PX;
                background: linear-gradient(250deg, #15A695 0%, #06807B 100%);
            }
        }
    }
    .swiper-button-prev {
        background: url('https://s20.lgstatic.com/growth/activity/20211129/1638186107785.png') no-repeat center;
        background-size: 100% 100%;
        width: 56PX;
        height: 56PX;
        top: 50%;
        left: 0;
    }  
    .swiper-button-next {
        background: url('https://s20.lgstatic.com/growth/activity/20211129/1638186188262.png') no-repeat center;
        background-size: 100% 100%;
        width: 56PX;
        height: 56PX;
        top: 50%;
        right: 0;
    } 
    }
.footer {
    position: fixed;
    bottom: 0;
    z-index: 999;
    width: 100%;
    cursor: pointer;
    // height: 117PX;
    background-position: center;
    background-repeat: no-repeat;
    background-size: auto;
    border: none;
    font-size: 0;
    .iconBox {
        position: absolute;
        top: -30PX;
        left: 50%;
        transform: translate(-50%);
        z-index: 9999;
        width: 1060PX;
        .icon {
            float: right;
            width: 134PX;
        }
    }
    img {
      width: 100%;
    }
    .text-loop {
      position: absolute;
      width: 215PX;
      height: 37PX;
      right: 31.5%;
      top: 50%;
      transform: translateY(-50%);
      border: none;
      border-image-width: 0;
    }
}
.course-section {
    width: 1200PX;
    background: #FFFFFF;
    border-radius: 10PX;
    height: 500PX;
    margin: 0 auto;
    box-sizing: border-box;
}
.section-left {
    width: 140PX;
    background: #F07234;
    border-radius: 10PX;
    padding-top: 24PX;
    box-sizing: border-box;
}
.s-l-i {
    width: 122PX;
    height: 38PX;
    border-radius: 19PX;
    color: white;
    background: #F07234;
    border: none;
    margin: 8PX 0;
}
.s-l-i-a {
    background: #FFFFFF;
    color: #F07234;
}
.section-right {
    padding: 17PX 40PX;
    position: relative;
    .tips-tab {
        position: absolute;
        font-size: 14PX;
        color: #666;
        bottom: 10PX;
        right: 60PX;
    }
}
.n-top {
    padding: 8PX 0 12PX;
    border-bottom: 1PX solid #B7B7B7;
    font-size: 22PX;
    .n-t-d {
        color: #333333;
        font-weight: 600;
        padding-right: 48PX;
        min-width: 210PX;
    }
    .detail-course{
        font-weight: 600;
        color: #F07234;
        font-size: 22PX;
        cursor: pointer;
    }
}
.s-container {
    font-size: 18PX;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #666666;
}
.s-c-title {
    font-size: 20PX;
    font-weight: 500;
    color: #333333;
    position: relative;
    padding-left: 14PX;
    padding-bottom: 10PX;
    margin-top: 20PX;
    &:first-of-type {
        margin-top: 13PX;
    }
    &::before {
        position: absolute;
        content: '';
        width: 4PX;
        height: 20PX;
        margin-top: 4PX;
        left: 0;
        background: #F07234;
    }
}
.s-n-item {
    padding-left: 20PX;
    position: relative;
    &::before {
        width: 2PX;
        height: 2PX;
        border-radius: 50%;
        background: #666666;
        content: '';
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 5PX;
    }
}
.s-n-items {
    padding-left: 20PX;
    position: relative;
}
.its-2 {
    width: 100%;
    display: flex;
}
.sw-n-l {
    padding-left: 20PX;
    flex: 1;
}
.sw-n-r {
    flex: 1;
}
.section-main {
    width: 100%;
    min-width: 1200PX;
    height: 639PX;
    margin-top: -1PX;
    background-color: #F4F4F4;
    background-size: auto 100%;
    overflow: hidden;
}
.section-teacher{
    .swiper-button-prev {
        background: url('https://s20.lgstatic.com/growth/activity/20211129/1638187209140.png') no-repeat center;
        background-size: 100% 100%;
        width: 84PX;
        height: 84PX;
        left: -2PX;
        top: 40%;
    }  
    .swiper-button-next {
        background: url('https://s20.lgstatic.com/growth/activity/20211129/1638187220097.png') no-repeat center;
        background-size: 100% 100%;
        width: 84PX;
        height: 84PX;
        right: -2PX;
        top: 40%;
    }  
}
.section-program{
    position: relative;
    width: 100%;
    min-width: 900PX;
    // background: url("https://s21.lgstatic.com/growth/activity/20211124/1637724438372.png") no-repeat;
    // background-size: cover;
    .sw-section{
        .swiper-button-prev {
            background: url('https://s20.lgstatic.com/growth/activity/20211129/1638187209140.png') no-repeat center;
            background-size: 100% 100%;
            width: 84PX;
            height: 84PX;
        }  
        .swiper-button-next {
            background: url('https://s20.lgstatic.com/growth/activity/20211129/1638187220097.png') no-repeat center;
            background-size: 100% 100%;
            width: 84PX;
            height: 84PX;
        }   
    .swiper-slide {
        width: 100%;
        opacity: 0;
        img {
            display: block;
            width: 100%;
            height: 450PX;
            margin: 0 auto;
            object-fit: contain;
        }
        &.swiper-slide-active {
            opacity: 1;
        }
        &.swiper-slide-next, &.swiper-slide-prev {
            opacity: .5;
        }
    }
    }
}
.jump-btn-teacher{
    position: absolute;
    outline: 0;
    border:0;
    left: 50%;
    transform: translate(-50%);
    bottom: -110PX;
    width: 282PX;
    height: 56PX;
    line-height: 58PX;
    color: #003A4D;;
    border-radius: 8PX;
    border: 1PX solid #003A4D;
    align-items: center;
    font-size: 20PX;
    justify-content: center;
    background: #F6F7F7;
    img {
        width: 15PX;
        height: 20PX;
        margin-left: 14PX;
    }
}
.jump-btn-company{
    bottom: 120PX;
    height: 38PX;
    img {
        width: 100%;
        display: block;
    }
}
.tab-icon{
    position: fixed;
    right: 4%;
    bottom: 20%;
    box-sizing: border-box;
    font-size: 20PX;
    flex-direction: column;
    align-items: center;
    border-radius: 8PX;
    cursor: pointer;
    z-index: 11;
    box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.09);
    background: linear-gradient(181deg, #036275 0%, #015B74 100%);
    .top-bg{
        background: #fff;
        width: 100%;
        border-radius: 8PX 8PX 0 0 ;
    }
    .item{
        padding: 10PX 0;
        margin: 0px 5PX;
        color: #CDCDCD;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        img{
            width: 30PX;
        }
    }
    .learn{
           border-top: 1px solid #CDCDCD; 
           border-bottom: 1px solid #CDCDCD;
        }
    .toTop{
       background: linear-gradient(181deg, #036275 0%, #015B74 100%);
       color: #fff;
       height: 77PX;
       width: 100%;
       text-align: center;
       flex-direction: column;
       align-items: center;
       padding: 10PX;
       box-sizing: border-box;
       img{
            width: 18PX;
            height: 10PX;
            display: block;
            margin-top: 10PX;
       }
       border-radius: 0 0 8PX 8PX;
    }
}
#sw-wrap{
   .swiper-slide{
        width: 382PX !important;
        height: 297PX;
        // margin-right: 21PX;
        color: #fff;
        .s-text{
            position: absolute;
            top: 40PX;
            left: 0;
            width: 100%;
            height: 100%;
            padding: 0 15PX;
        }
        .top{
            width: 100%;
            height: 64PX;
            line-height: 64PX;
            text-align: left;
            font-size: 20PX;
            padding-top: 3PX;
            align-items: center;
            .head-icon{
                width: 23PX;
                height: 23PX;
                display: block;
            }
            p{
                font-size: 20PX;
                margin: 0 5PX;
            }
            .spaceY{
                width: 1PX;
                height: 18PX;
                background-color: #fff;
                display: block;
                padding: 0;
            }
        }
        .bottom{
            font-size: 16PX;
            height: 200PX;
            padding: 20PX 0;
            flex-direction: column;
            justify-content: space-around;
            li{
                position: relative;
                padding-left: 10PX;
                .poit{
                    display: inline-block;
                    vertical-align: middle;
                    position: absolute;
                    top:10PX;
                    left:0;
                    width: 4PX;
                    height: 4PX;
                    border-radius: 50%;
                    background-color: #fff;
                }
            }
            
        }
   }
}
#pr-wrap{
    height: 780PX;
}
.poiter{
    cursor: pointer;
}
.section-bg{
    position: absolute;
    top: 0;
    left: 0;
    img{
        object-fit: contain;
    }
}
#section_end{
    background-color: #005f7a;
    padding-bottom: 80PX;
}
</style>
